import { mobile } from '@bilibili-maoer/web-utils';
export { DEFAULT_REGION, DOC_DUTY_URL, DOC_PRIVACY_URL, FEEDBACK_URL } from './constants.js';
import '../../toast/index.js';
import '@babel/runtime-corejs3/helpers/toConsumableArray';
import '@babel/runtime-corejs3/helpers/classCallCheck';
import '@babel/runtime-corejs3/helpers/createClass';
import '@babel/runtime-corejs3/core-js/parse-int';
import '@babel/runtime-corejs3/core-js/object/keys';
import '@babel/runtime-corejs3/core-js/promise';
import 'lodash-es';

var isMobileSlideBar = function isMobileSlideBar() {
  return mobile.isIOS() || mobile.isAndroid();
};

export { isMobileSlideBar };
